import React from "react";
import ActCard from "../LandingPage/ActsContainer/ActCard";

const Alternates=({actsData})=>{

    const container = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
        flexWrap:"wrap",
        overflowY:"scroll",
        overflowX:"hidden",
        gap:"7px",
        scrollbarColor: "#00ADB5 #222831",
        scrollbarWidth: "thin",
        boxSizing: "border-box",
    }

    return <div style={container}>
        {actsData.map((card, index) => (
            <ActCard
                key={index}
                id={card.id}
                image={card.image}
                text={card.text}
                type={card.type}
                value={card.value}
            />
        ))}
    </div>
}

export default Alternates;